import { all, call, put } from 'redux-saga/effects';
import {
  FETCH_COUNTRIES_SUCCESS,
  FETCH_LISTINGS_SUCCESS,
  FETCH_SPECIALITIES_SUCCESS,
  FETCH_QUALIFICATIONS_SUCCESS,
  FETCH_SPECIALITIES_FAILED,
  FETCH_QUALIFICATIONS_FAILED,
  FETCH_COUNTRIES_FAILED,
  FETCH_DOMAIN_DETAILS_SUCCESS,
  FETCH_DOMAIN_DETAILS_FAILED,
} from '../actions/types';
import { getOrgDetailsByDomainService } from '../services/apiServices';
import { getCountriesService, getQualificationsService, getRegionsService, getSpecialitiesService } from '../services/listings';

export function* fetchListings() {
  try {
    const [regions, qualifications, specialities] = yield all([call(getRegionsService), call(getQualificationsService), call(getSpecialitiesService)]);
    yield put({
      type: FETCH_LISTINGS_SUCCESS,
      data: { regions: regions.regions, qualifications: qualifications.qualifications, specialities: specialities.specialities },
    });
  } catch (error) {
    console.log('Error', error);
  }
}

export function* fetchSpecialities() {
  try {
    const specialities = yield call(getSpecialitiesService);
    yield put({
      type: FETCH_SPECIALITIES_SUCCESS,
      data: specialities.specialities,
    });
  } catch (error) {
    yield put({ type: FETCH_SPECIALITIES_FAILED, data: error.response.data.message });
  }
}

export function* fetchQualifications() {
  try {
    const result = yield call(getQualificationsService);
    yield put({
      type: FETCH_QUALIFICATIONS_SUCCESS,
      data: result.qualifications,
    });
  } catch (error) {
    yield put({ type: FETCH_QUALIFICATIONS_FAILED, data: error.response.data.message });
  }
}

export function* fetchCountries() {
  try {
    const countries = yield call(getCountriesService);
    yield put({ type: FETCH_COUNTRIES_SUCCESS, data: countries.countries });
  } catch (error) {
    yield put({ type: FETCH_COUNTRIES_FAILED, data: error.response.data.message });
  }
}

export function* fetchDomainDetails(action) {
  try {
    const result = yield call(getOrgDetailsByDomainService, action.payload);
    localStorage.setItem('orgType', result.organization.orgType);
    localStorage.setItem('orgID', result.organization.id);
    yield put({ type: FETCH_DOMAIN_DETAILS_SUCCESS, data: result.organization });
  } catch (error) {
    yield put({ type: FETCH_DOMAIN_DETAILS_FAILED, data: error.response && error.response.data && error.response.data.message });
  }
}
